import { render } from "./SecurityManagement.vue?vue&type=template&id=91f8a074&scoped=true"
import script from "./SecurityManagement.vue?vue&type=script&lang=js"
export * from "./SecurityManagement.vue?vue&type=script&lang=js"

import "./SecurityManagement.vue?vue&type=style&index=0&id=91f8a074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f8a074"]])

export default __exports__